/* istanbul ignore file */
import AccountPage from './index';

const AccountCategoryPage = AccountPage;

export default AccountCategoryPage;
